import {
    QueryClient,
    UseMutationOptions,
    useMutation,
    useQuery
  } from "@tanstack/react-query";
  import { IWaitingListDetailsInfo } from "./dtos";
  import {
    getGetWaitingListLeadDetails,
    patchAcquireWaitingListLead,
    patchRejectWaitingListLead
  } from "../../../../constants/reactQueryKey";
  import ApiError from "../../../../lib/ApiError";
  import { AnfragenManagerClient } from "lib/httpService";
  import { DayOfWeek, BookingPotentialCategory, PhoneSort, ILeadPhoneNumber, IProductCriteriaInfo } from "../../../../types";
  
  // Beispiel-Daten für PhoneNumbers anhand der ILeadPhoneNumber Schnittstelle
  const mockPhoneNumbers: ILeadPhoneNumber[] = [
    { type: PhoneSort.Telephone, internationalNoBlanks: "+49123456789" },
    { type: PhoneSort.Mobile, internationalNoBlanks: "+4915798765432" }
  ];
  
  // Beispiel-Daten für Product Criteria unter Verwendung der IProductCriteriaInfo Schnittstelle
  const mockProductCriteria: IProductCriteriaInfo[] = [
    {
      criteriaName: "Color",
      value: "Blue"
    },
    {
      criteriaName: "WeekDay",
      value: DayOfWeek.Monday
    },
    {
      criteriaName: "BookingPotential",
      value: BookingPotentialCategory.LeadPrice1
    }
  ];
  
  // Erstelle Mock-Daten für die WaitingListLeadDetails inkl. Product Criteria und PhoneNumbers
  const mockWaitingListDetails: IWaitingListDetailsInfo = {
    waitingListLeadNumber: "WL-12345",
    waitingListLeadState: 1, // Beispiel: 0 für einen Anfangszustand
    firstName: "Max",
    lastName: "Mustermann",
    clientAvailability: "Mo-Fr 09:00 - 17:00",
    productName: "Mock-Produkt",
    requestZipCode: "12345",
    requestRegion: "Musterregion",
    phoneNumbers: mockPhoneNumbers,
    productCriteriaList: mockProductCriteria,
    isPersonalProduct: false,
    isClosedByClient: false
  };
  
  export const useGetWaitingListLeadDetails = (
    secureId: string,
    options = {}
  ) => {
    return useQuery(
      [getGetWaitingListLeadDetails, secureId],
      async () => {
        // Simuliere eine Verzögerung von 500ms
        await new Promise(resolve => setTimeout(resolve, 500));
        return mockWaitingListDetails;
      },
      {
        ...options
      }
    );
  };
  
  export const usePatchMakeWaitingListLeadAcquired = (
    secureId: string,
    options: UseMutationOptions<void, ApiError, void, unknown> = {}
  ) => {
    return useMutation<void, ApiError, void>({
      mutationKey: [patchAcquireWaitingListLead, secureId],
      mutationFn: async () => {
        // Simuliere eine Mutation mit einer Verzögerung
        await new Promise(resolve => setTimeout(resolve, 500));
        return;
      },
      ...options
    });
  };
  
  export const usePatchMakeWaitingListLeadRejected = (
    secureId: string,
    options: UseMutationOptions<void, ApiError, void, unknown> = {}
  ) => {
    return useMutation<void, ApiError, void>({
      mutationKey: [patchRejectWaitingListLead, secureId],
      mutationFn: async () => {
        // Simuliere eine Mutation mit einer Verzögerung
        await new Promise(resolve => setTimeout(resolve, 500));
        return;
      },
      ...options
    });
  };
  
  export const invalidateWaitingListLeadQueries = async (
    queryClient: QueryClient
  ) => {
    queryClient.invalidateQueries([getGetWaitingListLeadDetails]);
  };
  